export default `
<article class="clearfix" >
    <ut-community-follow-btn [user]="$ctrl.user" ng-if="$ctrl.user.current_user_permissions['follow']"></ut-community-follow-btn>
    <a ui-sref="profile.about({profileId: $ctrl.user.slug})" class="profile-thumb" bg-img="{{$ctrl.user.avatar_url}}"></a>
    <h5><a ui-sref="profile.about({profileId: $ctrl.user.slug})">{{$ctrl.user.name}}<small>@{{$ctrl.user.slug}}</small></a></h5>
</article>
`;
